import { FC } from 'react'
import { useIntl } from 'react-intl'

import { Divider, Flex, List } from 'antd'

import { Page } from '../../components/page'
import { Title } from '../../components/text/Title'
import { useArticlesQuery } from '../../graphql'

import { ArticleCard } from './ArticleCard'

const Blog: FC = () => {
  const { formatMessage } = useIntl()
  const { data, loading } = useArticlesQuery()
  const articlesByCategory: Record<string, ArticleCardFragment[]> = {}
  data?.articles.forEach((it) => {
    const category = it?.category?.name
    if (category) {
      if (!articlesByCategory[category]) articlesByCategory[category] = []
      articlesByCategory[category].push(it)
    }
  })
  return (
    <Page loading={loading} title={formatMessage({ id: 'blog.header' })}>
      {Object.entries(articlesByCategory)?.map(([category, articles]) => (
        <Flex key={category} vertical>
          <Title level={2}>{category}</Title>
          <List
            loading={loading}
            grid={{ gutter: 16, xs: 1, sm: 1, md: 2, lg: 2, xl: 3, xxl: 3 }}
            dataSource={articles}
            renderItem={(it) =>
              it?.publishedAt && (
                <List.Item>
                  <ArticleCard {...it} />
                </List.Item>
              )
            }
            pagination={{ pageSize: 3, hideOnSinglePage: true }}
          >
            {articles.length === 0 ? null : null}
          </List>
          <Divider />
        </Flex>
      ))}
    </Page>
  )
}

export { Blog as default }
